<header class="main-header">

    <!-- Logo -->
    <a routerLink="/dashboard" class="logo desktopVisibility ">
        <!-- mini logo for sidebar mini 50x50 pixels -->
        <span class="logo-mini">DRINK</span>
        <!-- logo for regular state and mobile devices -->
        <span class="logo-lg">
            <img src="assets/img/logo.png" width="120" alt="DrinkWell">
        </span>
    </a>

    <!-- Header Navbar: style can be found in header.less -->
    <nav class="navbar navbar-static-top">
        <!-- Sidebar toggle button-->
        <a href="#" class="sidebar-toggle" data-toggle="push-menu" role="button">
            <span class="sr-only">Toggle navigation</span>
        </a>
        <!-- Navbar Right Menu -->
        <div class="navbar-custom-menu">
            <ul class="nav navbar-nav desktopVisibility">
                <li>
                    <a [routerLink]="['/setting/user/change-password']" class="btn-default">
                        <strong>Change Password</strong>
                    </a>
                </li>

                <li>
                    <a (click)="authService.removeToken()" style="cursor: pointer;" class="btn-default">
                        <strong>Logout</strong>
                    </a>
                </li>
            </ul>
            <a routerLink="/dashboard" class="logo mobileVisibility ">
                <!-- mini logo for sidebar mini 50x50 pixels -->
                <span class="logo-mini">DRINK</span>
                <!-- logo for regular state and mobile devices -->
                <span class="logo-lg">
                    <img class="mobileLogo" src="assets/img/logo.png" width="120" alt="DrinkWell">
                </span>
            </a>
            <ul class="nav navbar-nav mobileVisibility">

                <li class="dropdown notifications-menu">

                    <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                        <img width="20px" src="../../../assets/img/dot.svg" alt="">
                    </a>
                    <ul class="dropdown-menu">
                        <li>
                            <a [routerLink]="['/setting/user/change-password']" class="btn-default mobile_menu">
                                <strong>Change Password</strong>
                            </a>
                        </li>

                        <li>
                            <a (click)="authService.removeToken()" style="cursor: pointer;" class="btn-default">
                                <strong>Logout</strong>
                            </a>
                        </li>
                    </ul>
            </ul>
        </div>

    </nav>
</header>

<app-sidebar></app-sidebar>
